export const EMAIL_FORMAT_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const CC_EMAIL_SEPARATOR = ';';

export const migrateCcFromLegacy = (stored) => {
  if (stored == null || stored === '') return '';
  return String(stored).replace(/,/g, CC_EMAIL_SEPARATOR).replace(/\s/g, '');
};

export const validateCcList = (value) => {
  if (value == null || String(value).trim() === '') return true;
  const s = String(value);
  if (/\s/.test(s)) {
    return 'No uses espacios. Separa los correos con punto y coma (;).';
  }
  if (s.includes(',')) {
    return 'Usa punto y coma (;) para separar correos, no coma.';
  }
  const partes = s.split(CC_EMAIL_SEPARATOR).filter((p) => p.length > 0);
  if (partes.length === 0) return true;
  const todasValidas = partes.every((p) => EMAIL_FORMAT_REGEX.test(p));
  return (
    todasValidas ||
    'Cada correo en CC debe ser válido (sepáralos con punto y coma ;)'
  );
};

export const normalizedCopyCc = (raw) => {
  if (raw == null || String(raw).trim() === '') return '';
  return String(raw)
    .split(CC_EMAIL_SEPARATOR)
    .filter((p) => p.length > 0)
    .join(CC_EMAIL_SEPARATOR);
};
